import {
  REQUEST_WEDDING_LIST
} from './mutation-types'

export default {
  [REQUEST_WEDDING_LIST](state, receivedData) {
    state.weddingList = receivedData.content
    state.weddingListCount = receivedData.totalElements
  }
}